import React, { FunctionComponent, useMemo, useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { store } from "react-notifications-component"
import { useHistory, useRouteMatch, Link, Route } from "react-router-dom"
import { notificationOptions } from "../../../api/Definitions"
import Loader from "../../../components/Loader/Loader"
import Seo from "../../../components/Seo/Seo"
import { iInspectorProps, iResponse } from "../../../definitions/interfaces"
import { iUser } from "../../../definitions/User"
import { get, post } from "../../../store/data/actions"
import ProfileOverview from "./Overview"
import { getProfileRoutes } from "./routes"
import ProfileSettings from "./Settings"
import ProfileSubscription from "./Subscription"

const Profile: FunctionComponent<iInspectorProps<iUser>> = ({ item }) => {
  const match = useRouteMatch()
  const history = useHistory()

  const methods = useForm({ defaultValues: item, shouldUnregister: false })

  const handleCancelSubscription = () => {
    post({ link: "/v1/cancel-user-subscription" })
      .then((res) => {
        store.addNotification({
          title: "Success!",
          message: "Subscription canceled!",
          // message: "teodosii@react-notifications-component",
          type: "success",
          ...notificationOptions,
        })
      })
      .catch((e) => {
        if (e.response && e.response.data) {
          store.addNotification({
            message: e.response.data.reason,
            type: "danger",
            ...notificationOptions,
          })
        } else {
          store.addNotification({
            message: "Something went wrong!",
            type: "danger",
            ...notificationOptions,
          })
        }
      })
  }

  const navRoutes = getProfileRoutes({ urlPrefix: match.url })
  return (
    <FormProvider {...methods}>
      <Seo title="Profile" />
      <div className="inspector-header">
        <div className="inspector-cover-wrap">
          <div className="inspector-cover-overlay">
            <div className="inspector-headline"></div>
            <h1 className="inspector-title">My Profile</h1>
          </div>
        </div>
        <div className="inspector-navigation">
          <ul>
            {navRoutes.map((n, i) => (
              <li
                key={i}
                className={
                  history.location.pathname === n.route ? "active" : ""
                }
              >
                <Link to={n.route} replace>
                  <span>{n.title}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="inspector">
        <form className="inspector-form">
          <Route exact path={match.path}>
            <ProfileOverview item={item} />
          </Route>
          <Route exact path={match.path + "/settings"}>
            <ProfileSettings />
          </Route>
          <Route exact path={match.path + "/subscription"}>
            <ProfileSubscription
              item={item}
              handleCancelSubscription={handleCancelSubscription}
            />
          </Route>
        </form>
      </div>
    </FormProvider>
  )
}

const ProfileLoader: FunctionComponent = () => {
  const [isLoading, setLoading] = useState(true)
  const [profile, setProfile] = useState<iUser>()
  const loadProfile = () => {
    get<iResponse<iUser>>({
      link: "/v1/profile",
    }).then((res) => {
      console.log(res)

      setLoading(false)
      setProfile(res.data)
    })
  }

  useMemo(() => {
    loadProfile()
  }, [])
  return isLoading ? (
    <Loader />
  ) : profile ? (
    <Profile reload={loadProfile} item={profile} />
  ) : null
}

export default ProfileLoader
